import type { MutationHookResult, QueryHookResult } from 'react-query-kit';

export class ApiError extends Error {
  public readonly response: Response;
  public readonly status: number;

  public constructor(response: Response) {
    super(`Got status ${response.status.toString()} fetching ${response.url}`);
    this.name = 'ApiError';
    this.response = response;
    this.status = response.status;
  }
}

export const isApiError = (error: Error): error is ApiError => 'response' in error && error.response !== undefined;

type Operation<T, U> = QueryHookResult<unknown, ApiError> | MutationHookResult<T, ApiError, U>;

export const isUnauthorized = <T, U>(op: Operation<T, U>): boolean =>
  op.isError && isApiError(op.error) && op.error.status === 401;
